<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "Accidentes de trabajo y enfermedades laborales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },
        {
          text: "Accidentes de trabajo y enfermedades laborales",
          active: true,
        },
      ],
      text: `
          Ad leggings keytar, brunch id art party dolor labore. Pitchfork yr enim lo-fi before they sold out qui. Tumblr farm-to-table bicycle rights whatever. Anim keffiyeh carles cardigan. Velit seitan mcsweeney's photo booth 3 wolf moon irure. Cosby sweater lomo jean shorts, williamsburg hoodie minim qui you probably haven't heard of them et cardigan trust fund culpa biodiesel wes anderson aesthetic. Nihil tattooed accusamus, cred irony biodiesel keffiyeh artisan ullamco consequat.
        `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Vuelve a la página anterior real. Esta vista se abre tanto desde la base
     * de conocimiento como desde su ítem, así que no se puede fijar el destino.
     * Si no hay historial (entrada directa o refresh) cae a la base de conocimiento.
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/forms/general");
      }
    },

    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
    
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  

   
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body"> 
            <div class="row">
              <div class="col-6">
                <h4 class="header-title">Accidentes de trabajo y enfermedades laborales</h4>
              </div>

              <div class="col-6 text-right">
                <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

           

            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                 <!-- <b-list-group-item href="#list-item-1"
                    >¿QUÉ ES EL COMITÉ COPPASST?</b-list-group-item
                  >-->
                  <b-list-group-item href="#list-item-1"
                    >¿Que son accidentes de trabajo y enfermedades laborales?</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-2"
                    >Enfermedad laboral</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-3"
                    >Calificación de Origen y Pérdida de Capacidad Laboral </b-list-group-item
                  >
                <b-list-group-item href="#list-item-4"
                    >Investigación de accidentes graves y fatales</b-list-group-item
                  >
                  <!--     <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->
                  
                 
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 300px"
                >
                  <!--<h4 id="list-item-1">¿Qué es el comité copasst? </h4>
                  <p>...</p>-->
                  <h4 id="list-item-1">¿Que son accidentes de trabajo y enfermedades laborales?</h4>
                   <p>En el artículo 3 de la Ley 1562 de 2012 se define el accidente de trabajo como “Todo suceso repentino que sobrevenga por causa o con ocasión del trabajo, y que produzca en el trabajador una lesión orgánica, una perturbación funcional o psiquiátrica, una invalidez o la muerte. <br/> <br/>

                    Es también accidente de trabajo aquel que se produce durante la ejecución de las órdenes del empleador, o contratante durante la ejecución de una labor bajo su autoridad, aun fuera del lugar u horas de trabajo. <br/> <br/>

                    Igualmente se considera accidente de trabajo el que se produzca durante el traslado de los trabajadores o contratistas desde su residencia a los lugares de trabajo o viceversa, cuando el transporte lo suministre el empleador. <br/> <br/>

                    También se considerará como accidente de trabajo el ocurrido durante el ejercicio de la función sindical, aunque el trabajador se encuentre en permiso sindical siempre que el accidente se produzca en cumplimiento de dicha función. <br/> <br/>

                    De igual forma se considera accidente de trabajo el que se produzca por la ejecución de actividades recreativas, deportivas o culturales, cuando se actúe por cuenta o en representación del empleador o de la empresa usuaria cuando se trate de trabajadores de empresas de servicios temporales que se encuentren en misión”. <br/> <br/>
                    </p>
                 
                 
                  
                    
                 <h4 id="list-item-2">Enfermedad laboral</h4>
                  <p>Se define en el artículo 4 de la misma ley como “La contraída como resultado de la exposición a factores de riesgo inherentes a la actividad laboral o del medio en el que el trabajador se ha visto obligado a trabajar. <br/><br/>

                  El gobierno nacional, determinará, en forma periódica, las enfermedades que se consideran como laborales y los casos en que una enfermedad no figure en la tabla de enfermedades laborales, pero se demuestre la relación de causalidad con los factores de riesgo ocupacionales será reconocida como enfermedad laboral”. <br/><br/>
                  Para obtener mayor información con respecto a las enfermedades laborales se recomienda consultar el Decreto 1477 de 2014, por el cual se expide la Nueva Tabla de Enfermedades Laborales a través de: <br/><br/>
                  <a href="http://www.mintrabajo.gov.co/normatividad-agosto-decretos-2014/3708-decreto-1477-del-5-de-agosto-de-2014.html">http://www.mintrabajo.gov.co/normatividad-agosto-decretos-2014/3708-decreto-1477-del-5-de-agosto-de-2014.html</a>   <br/> <br/>
                  </p>
                  <h4 id="list-item-3">Calificación de Origen y Pérdida de Capacidad Laboral </h4>
                  <p>Como se indicó anteriormente, definir si un accidente o enfermedad es de origen común o laboral tiene unas implicaciones para efectos de determinar quién asume las prestaciones y el monto de las mismas, por lo cual es muy importante conocer que existe un proceso de Calificación de origen y pérdida de capacidad laboral que en términos generales se puede describir así: <br/><br>
                   <img class="ml-5" style="position: center;" src="@/assets/images/accidentes.png" width="600" height="281"><br/><br/>
                  El Decreto 1507 de 2014 consagra el Manual Único para la Calificación de la Pérdida de la Capacidad Laboral y Ocupacional, en esta calificación se hace una valoración de las deficiencias, del rol laboral, del rol ocupacional y otras áreas ocupacionales.</p>
                  <h4  id="list-item-4">Investigación de accidentes graves y fatales</h4>
                  La investigación de accidentes de trabajo se encuentra reglamentado en la resolución 1401 de 2007 y está definida como: “Proceso sistemático de determinación y ordenación de causas, hechos o situaciones que generaron o favorecieron la ocurrencia del accidente o incidente, que se realiza con el objeto de prevenir su repetición, mediante el control de los riesgos que lo produjeron”. <br/> <br/>

                Accidente grave:” Aquel que trae como consecuencia amputación de cualquier segmento corporal; fractura de huesos largos (fémur, tibia, peroné, húmero, radio y cúbito); trauma craneoencefálico; quemaduras de segundo y tercer grado; lesiones severas de mano, tales como aplastamiento o quemaduras; lesiones severas de columna vertebral con compromiso de médula espinal; lesiones oculares que comprometan la agudeza o el campo visual o lesiones que comprometan la capacidad auditiva.” <br/> <br/>

                El artículo 4 de la resolución 1401 de 2007 define las siguientes funciones para los empleadores: <br/> <br/>

                •	Investigar todos los incidentes y accidentes. <br/>
                •	Conformar el Equipo Investigador. <br/>
                •	Remitir informes a la ARL. <br/>
                •	Adoptar metodología y formato. <br/>
                •	Registro adecuado de información. <br/>
                •	Proveer recursos e implementar las medidas y acciones correctivas <br/>
                •	Registrar seguimiento de acciones. <br/>
                •	Indicadores de control y seguimiento <br/>
                •	Llevar archivo. <br/> <br/>

                En el momento en que ocurren estos sucesos el empleador o contratante tiene unas obligaciones relacionadas con el informe del mismo que no puede olvidar puesto que le pueden traer cuantiosas sanciones. El Decreto 1295 de 1994, artículo 62, establece que se debe reportar todo accidente de trabajo o enfermedad laboral a la ARL y EPS, simultáneamente, dentro de los 2 días hábiles siguientes, en el formato que para estos efectos adopten las entidades. <br/> <br/>

                También, cuando se presentan accidentes graves o mortales se debe hacer una investigación conforme lo indica la Ley y esta investigación debe ser remitida a la ARL dentro de los 15 días calendario después de la ocurrencia del evento. <br/> <br/>

                En el decreto 1886 de 2015, se requiere incluso para las empresas mineras que esta investigación sea enviada también a la autoridad minera, dentro de los 15 días calendario siguientes a la ocurrencia del evento. <br/> <br/>

                Además, el Artículo 2.2.4.1.7. del Decreto Único Reglamentario del Sector Trabajo, establece la obligación para empleadores y contratantes de reportar al Ministerio del Trabajo los accidentes graves, mortales y enfermedades laborales, dentro de los dos 2 días hábiles siguientes al accidente o del recibo del diagnóstico de la enfermedad, esto, independientemente del reporte que deben realizar a la ARL y EPS. <br/> <br/>

                La importancia de la realización de la investigación de los accidentes e incidentes, además de dar cumplimiento a la legislación, es la siguiente: <br/> <br/>

                •	Permite conocer bien los hechos sucedidos, entender como ocurren los eventos. <br/>
                •	Ayuda a entender las causas que han producido accidentes. <br/>
                •	Implementar acciones que aporten a eliminar las causas para evitar casos similares. <br/>
                •	Aprovechar la experiencia para la prevención y charlas de lecciones aprendidas a todo el personal trabajador. <br/> <br/>

                Estos son los pasos para realizar una buena investigación de un accidente e incidente: <br/> <br/>

                •	Conformar el equipo investigador: Este debe estar conformado por el jefe inmediato o supervisor del trabajador accidentado, 1 Representante del COPASST o el Vigía y el encargado de Seguridad y Salud en el Trabajo. <br/>
                •	Cuando el accidente se considere grave o produzca la muerte, en la investigación debe participar un profesional con licencia en Seguridad y Salud en el Trabajo propio o contratado, así como el personal de la empresa encargado del diseño de normas, procesos y/o mantenimiento. <br/>
                •	Visita de reconocimiento al área donde se presentó el evento con el fin de identificar posibles condiciones inseguras que ocasionaron el evento. <br/>
                •	Realización de entrevistas con el trabajador lesionado y los testigos. <br/>
                •	Definir un método para la determinación de las causas del evento. <br/>
                •	Determinar las causas de la ocurrencia del evento. Estas causas están divididas en básicas e inmediatas. <br/> <br/>

                      o	Las causas básicas son las causas reales que se manifiestan detrás de los síntomas; razones por las cuales ocurren los actos y condiciones subestándares o inseguros; factores que una vez identificados permiten un control administrativo significativo. Las causas básicas ayudan a explicar por qué se cometen actos subestándares o inseguros y por qué existen condiciones subestándares o inseguras. <br/>

                      o	Causas inmediatas: Circunstancias que se presentan justamente antes del contacto; por lo general son observables o se hacen sentir. Se clasifican en actos subestándares o actos inseguros (comportamientos que podrían dar paso a la ocurrencia de un accidente o incidente) y condiciones subestándares o condiciones inseguras (circunstancias que podrían dar paso a la ocurrencia de un accidente o incidente). <br/> <br/>

                •	Determinar el plan de acción para la corrección de la situación encontrada y para la eliminación de las causas básicas del evento. <br/>
                •	Realizar informe de la investigación y remitirlo a las autoridades cuando sea necesario. <br/>

                Como apoyo a la identificación de las causas y para la determinación de los planes de acción se recomienda consultar la norma NTC 3701. “Guía para la clasificación, registro y estadística de accidentes del trabajo y enfermedades profesionales” <br/> <br/>
                <br><br><br><br><br><br><br><br><br><br><br> 
                  <!--  <h4 id="list-item-6">Item 6</h4>
                  <p>{{ text }}</p> 
                  
                  <h4 hidden id="list-item-5"></h4>
                  <p>{{ text }}</p>
                   <h4 hidden id="list-item-6"></h4>
                  <p>{{ text }}</p>-->
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
